export default __webpack_public_path__ + "dac0bcd4430a84bf1cf368753e9ed68a.jpg";